<template>
    <DCard padding>
        <ZenDeskForm
            :zen-desk-settings="zenDeskSettings"
            :errors="errors"
            @submit-form="submitData"
        />
    </DCard>
</template>

<script setup>
import ZenDeskForm from '~@/Components/Settings/ZenDeskSettings/Form'
import { route } from '~@/Composables/route'

defineProps({
    zenDeskSettings: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const submitData = (form) => {
    form.post(route('settings.zen-desk-settings.store'))
}

</script>

<script>
export default {
    name: 'ZenDeskCrate'
}
</script>
